<template>
  <div>
    <PageHead title="预约管理"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex" v-if="isRadio == 1">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">部门：</div>
              <a-tree-select
                v-model="queryForm.organizationId"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName',
                }"
              >
              </a-tree-select>
            </div>
            <div class="query-view mr20">
              <div class="query-view-lable">日期：</div>
              <a-date-picker
                class="w200 ml20"
                valueFormat="YYYY-MM-DD"
                v-model="queryForm.makeDate"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">办理阶段：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.time"
              >
                <a-select-option :value="1">全天</a-select-option>
                <a-select-option :value="2">上午</a-select-option>
                <a-select-option :value="3">下午</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="search-flex" v-if="isRadio == 2">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">部门：</div>
              <a-tree-select
                v-model="queryForm.organizationId"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName',
                }"
              >
              </a-tree-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit1" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns mt20">
        <a-button type="primary" @click="goDetial()" icon="plus">
          新增预约</a-button
        >
        <!-- <span class="statistics"> 检索统计： {{ total }} 条 </span> -->
        <a-radio-group
          class="statistics"
          v-model="isRadio"
          button-style="solid"
        >
          <a-radio-button :value="1"> 列表查看 </a-radio-button>
          <a-radio-button :value="2"> 日历查看 </a-radio-button>
        </a-radio-group>
      </div>
      <template v-if="isRadio == 1">
        <a-table
          :pagination="false"
          :columns="columns"
          :data-source="data"
          :loading="loading"
          :row-key="(record) => record.id"
        >
          <span slot="index" slot-scope="text, record, index">
            {{ index + 1 + (page - 1) * 10 }}
          </span>
          <span slot="sendCount" slot-scope="text, record">
            <span v-if="record.officePhase == 1"> 全天 </span>
            <span v-if="record.officePhase == 2"> 上午 </span>
            <span v-if="record.officePhase == 3"> 下午 </span>
            {{ record.startTime }}-{{ record.endTime }}
          </span>
          <div slot="action" slot-scope="text, record">
            <a-button type="link" class="btn-link" @click="goDetial(record.id)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button>
          </div>
        </a-table>
        <div class="pagination">
          <a-pagination
            :current="page"
            :default-current="page"
            :total="total"
            :pageSize="size"
            @change="pageChange"
          />
        </div>
      </template>
      <a-calendar v-if="isRadio == 2">
        <ul slot="dateCellRender" slot-scope="value" class="events">
          <li v-for="item in getListData(value)" :key="item.content">
            <a-badge :status="item.type" :text="item.content" />
          </li>
        </ul>
        <!-- <template slot="monthCellRender" slot-scope="value">
          <div v-if="getMonthData(value)" class="notes-month">
            <section>{{ getMonthData(value) }}</section>
            <span>Backlog number</span>
          </div>
        </template> -->
      </a-calendar>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    scopedSlots: { customRender: "index" },
    width: 80,
  },

  {
    title: "公司名称/部门",
    dataIndex: "organizationName",
    key: "organizationName",
    ellipsis: true,
  },

  {
    title: "日期",
    dataIndex: "makeDate",
    key: "makeDate",
    ellipsis: true,
  },
  {
    title: "办理时间",
    dataIndex: "sendCount",
    key: "sendCount",
    scopedSlots: { customRender: "sendCount" },
    ellipsis: true,
  },
  {
    title: "可预约",
    dataIndex: "numbers",
    key: "numbers",
    scopedSlots: { customRender: "numbers" },
    ellipsis: true,
  },

  {
    title: "已预约",
    dataIndex: "hasNumber",
    key: "hasNumber",
    scopedSlots: { customRender: "hasNumber" },
    ellipsis: true,
  },

  {
    key: "operation",
    scopedSlots: { customRender: "action" },
    title: "操作",
    align: "left",
    width: 180,
  },
];

import {
  getReservationForm,
  delReservationForm,
  calendarlist,
} from "./api/api";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      timeHorizon: [], //时间范围
      queryForm: {},
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false,
      isRadio: 1, //1列表查看 2日历查看
      visible: false,
      addForm: {},
      monthData:[]
    };
  },

  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData, // 组织机构树
    }),
  },
  created() {
    this.getorganizeListFn();
    this.load();
  },
  methods: {
    ...mapActions(["getorganizeListFn"]),
    getListData(value) {
      let listData;
      switch (value.date()) {
        case 8:
          listData = [
            { type: "warning", content: "This is warning event." },
            { type: "success", content: "This is usual event." },
          ];
          break;
        case 10:
          listData = [
            { type: "warning", content: "This is warning event." },
            { type: "success", content: "This is usual event." },
            { type: "error", content: "This is error event." },
          ];
          break;
        case 15:
          listData = [
            { type: "warning", content: "This is warning event" },
            {
              type: "success",
              content: "This is very long usual event。。....",
            },
            { type: "error", content: "This is error event 1." },
            { type: "error", content: "This is error event 2." },
            { type: "error", content: "This is error event 3." },
            { type: "error", content: "This is error event 4." },
          ];
          break;
        default:
      }
      return listData || [];
    },

    getMonthData(value) {
      if (value.month() === 8) {
        return 1394;
      }
    },
    subMit1() {
      let params={
        organization_id:10061,
        month:3,
        year:2022
      }
      calendarlist(params).then((res) => {
        if (res.data.code == 0) {
          this.monthData = res.data.data;
          
        }
      });
    },
    // 拉取列表
    load() {
      this.loading = true;
      let params = this.queryForm;
      params.page = this.page;
      params.size = this.size;
      if (this.timeHorizon.length > 0) {
        //选择了时间范围
        params.startTime = this.timeHorizon[0];
        params.endTime = this.timeHorizon[1];
      } else {
        delete params.startTime;
        delete params.endTime;
      }
      getReservationForm(params).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          this.data = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: "确定删除吗?",
        okType: "danger",
        onOk: () => {
          delReservationForm({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success("删除成功");
              this.page = 1;
              this.load();
            }
          });
        },
      });
    },

    goDetial(id) {
      if (id) {
        this.$router.push("/addBookingManagement?id=" + id);
      } else {
        this.$router.push("/addBookingManagement");
      }
    },
    pageChange(pageber) {
      this.page = pageber;
      this.load();
    },
    cancel() {
      //取消
      this.queryForm = {};
      this.timeHorizon = [];
    },
    subMit() {
      console.log(this.timeHorizon);
      this.page = 1;
      this.load();
    },
  },
};
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.role-formCont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  .role-formlabel {
    width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  .role-formvalue {
    width: calc(100% - 120px);
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BookingManagement/index.vue